import api from "../store/api/api";

// Reverse geocode lookup lat/lon to real address
export const reverseGeocode = (lat, lon) => {
  return api.get("/geocode_reverse", { latlng: `${lat},${lon}` }).then((res) => {
    const results = (res.data && res.data.results) || [];
    const top = results[0];
    if (!top) return null;

    const location = top.geometry && top.geometry.location;

    return {
      key: top.place_id,
      primary: top.formatted_address,
      secondary: null,
      // the geocoder's own matched coordinates, not necessarily the coordinates
      // that were looked up -- falls back to the input if Google returns no geometry
      lat: location ? location.lat : lat,
      lon: location ? location.lng : lon,
    };
  });
};

export default reverseGeocode;
